import { atom } from 'jotai';

export const isSidebarAlertOpenState = atom<boolean>(false);
